export function hero() {
  return `
  <section class="hero">
    <div>
      <h1>See <em>what</em> actually changed.<br>Not 438 red lines.</h1>
      <p>cruxdiff understands structure — moved blocks, reordered keys, rows matched by ID — and separates the changes that matter from the noise. 100% in your browser.</p>
    </div>
    <div class="hero-badges">
      <span class="proof">&#10003; <b>no signup</b></span>
      <span class="proof">&#10003; share links live in the <b>URL</b></span>
      <span class="proof">&#10003; try it with <b>wifi off</b></span>
    </div>
  </section>`;
}
